import DelayDiv from 'modules/common/components/DelayDiv';
import React from 'react';
import HistogramCard, {
  useHistogramCard,
} from 'partial/components/HistogramCard';
import { formatNumber } from 'helper';
import Cards from './components/Cards';
import {
  useHorizontalBar,
  usePieChart,
  useTransactionHistogram,
} from './hooks';

const txnHistogramOptions = [
  {
    id: 'messages',
    label: 'TOTAL MESSAGES',
    hook: useTransactionHistogram,
    defaultChart: 'line',
    defaultMode: 'month',
  },
];

const subscribersBarOptions = [
  {
    id: 'subscribers',
    label: 'TOP 10 SUBSCRIBERS',
    hook: useHorizontalBar,
    defaultChart: 'horizontal-bar',
  },
];

const topMaskName = [
  {
    id: 'mask-names',
    label: 'TOP 10 SENDER NAMES',
    hook: usePieChart,
    defaultChart: 'pie',
  },
];

function Dashboard() {
  const transactionHistogram = useHistogramCard(txnHistogramOptions);
  const subscribersBar = useHistogramCard(subscribersBarOptions);
  const maskPie = useHistogramCard(topMaskName);
  return (
    <div className="space-y-8">
      <Cards />
      <DelayDiv
        className="col-span-1 xl:col-span-2"
        delay={100}
        loader={
          <div
            className="col-span-1 xl:col-span-2 bg-gray-50 animate-pulse rounded-lg"
            style={{ height: 361 }}
          />
        }
      >
        <HistogramCard {...transactionHistogram} />
      </DelayDiv>
      <div className="grid grid-cols-1 xl:grid-cols-5 gap-6 h-full">
        <DelayDiv
          className="col-span-1 xl:col-span-3 h-full"
          delay={100}
          loader={
            <div className="col-span-1 xl:col-span-2 bg-gray-50 animate-pulse rounded-lg h-full" />
          }
        >
          <HistogramCard
            cardClassName="h-full"
            {...subscribersBar}
            renderSummary={({ count, amount }) => (
              <div className="text-xs text-gray-300 space-x-3">
                <span>Transactions: {count}</span>
                <span>Collections: {formatNumber(amount)}</span>
              </div>
            )}
            customHeight={400}
            containerClass="!pr-0 pb-10  xl:pb-1"
          />
        </DelayDiv>
        <DelayDiv
          className="col-span-1 xl:col-span-2 h-full"
          delay={100}
          loader={
            <div
              className="col-span-1 xl:col-span-2 bg-gray-50 animate-pulse rounded-lg h-full"
              style={{ height: 400 }}
            />
          }
        >
          <HistogramCard
            {...maskPie}
            renderSummary={() => {}}
            cardClassName="h-full"
            customHeight={450}
            containerClass="!p-8"
          />
        </DelayDiv>
      </div>
    </div>
  );
}

export default Dashboard;
